export const ROUTES = {
  index: "/",
  contact_us: {
    index: '/contact-us'
  },
  terms_and_condition: {
    index: '/terms-and-conditions'
  },
  privacy_policy: {
    index: '/privacy-policy'
  },
  cookie_policy: {
    index: '/cookie-policy'
  },
  disclaimer: {
    index: '/disclaimer'
  },
  ticker_window_explanation: {
    index: '/ticker-window-explanation'
  },
  wildCard: "*"
};
